<template>
    <div class="report__table">
        <div class="columns custom--center is-variable is-0">
            <template v-if="thead.length && tbody.length">
                <template v-if="columnsView">
                    <div class="column column--left is-narrow">
                        <div class="report__table_left">
                            <table>
                                <thead>
                                <tr>
                                    <th :class="`report__table_left--${toKebabCase(theadFirst)}`">
                                        <span>{{ theadFirst | toString | toCapitalize }}</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="(item, index) in tbodyFirst"
                                    :key="index"
                                >
                                    <td
                                        :class="`report__table_left--${toKebabCase(item)}`"
                                    >
                                        <span>{{ item }}</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="column column--left column--scrollable">
                        <div class="report__table_right">
                            <table>
                                <thead>
                                <tr>
                                    <th
                                        v-for="(item, index) in theadRest"
                                        :key="index"
                                        :class="`report__table_right`"
                                    >
                                        <span>{{ item | toString | toCapitalize }}</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="(items, itemsIndex) in tbodyRest"
                                    :key="itemsIndex"
                                >
                                    <td
                                        v-for="(item, itemIndex) in items"
                                        :key="itemIndex"
                                        :class="`report__table_right--${toKebabCase(item)}`"
                                    >
                                        <span>{{ item }}</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="column column--scrollable">
                        <div class="report__table_right">
                            <table>
                                <thead>
                                <tr>
                                    <th
                                        v-for="(item, index) in thead"
                                        :key="index"
                                        :class="`report__table_right`"
                                    >
                                        <span>{{ item | toString | toCapitalize }}</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="(items, itemsIndex) in tbody"
                                    :key="itemsIndex"
                                >
                                    <td
                                        v-for="(item, itemIndex) in items"
                                        :key="itemIndex"
                                        :class="`report__table_right--${toKebabCase(item)}`"
                                    >
                                        <component-text
                                            :read-more-limit="50"
                                            :read-more-active="true"
                                        >{{ item ? (item.match(/^[0-9]{4}(.)[0-9]{2}(.)[0-9]{2}(.)[0-9]{2}(.)[0-9]{2}(.)[0-9]{2}$/) ? fromUTCDateTimeToLocalISOCustom(item) : item) : '-' }}</component-text>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="column">
                    <div class="report__table_notify">
                        <template v-if="loading">
                            <component-loading :name="`report-${reportName}`"></component-loading>
                        </template>
                        <template v-else-if="!loading && tbody === ''">
                            <component-note> {{ $t('ebs.reports.note.noDataHasBeenLoaded') }}
                            </component-note>
                        </template>
                        <template v-else-if="!loading && !tbody.length">
                            <template v-if="filters">
                                <component-note :danger="true">{{ $t('ebs.reports.note.selectedFilter') }}</component-note>
                            </template>
                            <template v-else>
                                <template v-if="thead.length">
                                    <component-empty-state
                                        :title="'No records match your selection.'"
                                        :content="''"
                                        :submit-button-active="false"
                                    ></component-empty-state>
                                </template>
                                <template v-else>
                                    <template v-if="isRouteExecuteResolved">
                                        <component-note>No data has been loaded into the report.</component-note>
                                    </template>
                                    <template v-else>
                                        <component-note :danger="true">Something went wrong while generating the report. Please try again or contact an administrator.</component-note>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import ComponentNote from '@/components/default/shared/ComponentNote'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  name: 'report-table',
  components: { ComponentText, ComponentEmptyState, ComponentNote, ComponentLoading },
  data () {
    return {
      loading: false
    }
  },
  props: {
    data: {
      type: [Object, String],
      required: true
    },
    columnsView: {
      type: Boolean,
      default: true
    },
    filters: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isRouteExecuteResolved () {
      return this.$route.name === 'ebs-report-builder-execute-resolved'
    },
    thead () {
      return this.data.labels
    },
    tbody () {
      return this.data.data
    },
    reportName () {
      return this.$route.params.slug
    },
    theadFirst () {
      const table = JSON.parse(JSON.stringify(this.thead))
      return table.shift()
    },
    theadRest () {
      const table = JSON.parse(JSON.stringify(this.thead))
      table.shift()
      return table
    },
    tbodyFirst () {
      const table = JSON.parse(JSON.stringify(this.tbody))
      let newTable = []
      for (let i = 0; i < table.length; i++) {
        newTable.push(table[i].shift())
      }
      return newTable
    },
    tbodyRest () {
      const table = JSON.parse(JSON.stringify(this.tbody))
      for (let i = 0; i < table.length; i++) {
        table[i].shift()
      }
      return table
    }
  },
  watch: {
    tbody (value) {
      if (value !== '') {
        this.loading = false
      }
    }
  },
  methods: {
    enableLoading () {
      this.loading = true
    },
    disableLoading () {
      this.loading = false
    }
  },
  mounted () {
    this.$eventBus.$on(`start-loading-report-${this.reportName}`, this.enableLoading)
    this.$eventBus.$on(`stop-loading-report-${this.reportName}`, this.disableLoading)
  },
  beforeDestroy () {
    this.$eventBus.$off(`start-loading-report-${this.reportName}`)
    this.$eventBus.$off(`stop-loading-report-${this.reportName}`)
  }
}
</script>
<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/reporttable";
</style>
